"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { GetMenusQuery } from "@/graphql/gql/graphql";
import HeaderContainer from "../HeaderContainer";

interface HeaderClientProps {
  initialData: GetMenusQuery | undefined;
}

export default function HeaderClient({ initialData }: HeaderClientProps) {
  const pathName = usePathname();
  const sport = useMemo(() => {
    return pathName?.split("/")?.[0];
  }, [pathName]);
  return <HeaderContainer sport={sport} initialData={initialData} />;
}
